<template>
  <slider />

  <the-nav />

  <div class="main-wrap favourites">
    <game-list-search :games="games?.filter(elem => favourites?.includes(elem.slug))" :string="'Любимые'" />

    <jackpot-block />

    <slot-topics />

    <bonuses-line />

    <play-line />

    <site-info />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Slider from '@/components/sliders/Slider'
import SlotTopics from '@/components/SlotTopics'
import PlayLine from '@/components/PlayLine'
import TheNav from '@/components/TheNav'
import JackpotBlock from '@/components/JackpotBlock'
import SiteInfo from '@/components/SiteInfo'
import { useI18n } from 'vue-i18n'
import BonusesLine from '@/components/BonusesLine.vue'
import GameListSearch from '@/components/GameListSearch'

export default {
  name: 'favourites',
  components: {
    GameListSearch,
    SiteInfo,
    BonusesLine,
    JackpotBlock,
    TheNav,
    PlayLine,
    SlotTopics,
    Slider,
  },
  setup() {
    const { t, locale } = useI18n()
    return { t, locale }
  },
  computed: {
    ...mapGetters(['favourites', 'games']),
  },
}
</script>
